import { Children, ComponentProps, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Responsive } from '../../utils';
import { themed, useTheme } from '../../themer';
import { FixedGrid, FixedGridItem } from './FixedGrid';
import { NumberOfColumns } from './theme';

export const StyledRow = styled(FixedGrid)`
	margin-bottom: ${themed(({ grid }) => grid.gutter.vertical.default)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-bottom: ${themed(({ grid }) => grid.gutter.vertical.mobileXL)};
	}
`;

export type IRowProps = Omit<ComponentProps<typeof FixedGrid>, 'columns'> & {
	children?: ReactNode;
	columns?: NumberOfColumns;
	className?: string;
};

export function Row({ children, className, columns }: IRowProps) {
	const { grid } = useTheme();

	return (
		<StyledRow
			className={className}
			columns={columns ?? grid.row.defaultColumns}
		>
			{Children.map(children, (child) => (
				<FixedGridItem>{child as ReactNode}</FixedGridItem>
			))}
		</StyledRow>
	);
}
